export const RE_INITIALIZE_CART_CATEGORY = 'RE_INITIALIZE_CART_CATEGORY'
export const SET_CART_CATEGORY_CATEGORIES = 'SET_CART_CATEGORY_CATEGORIES'
export const SET_CART_CATEGORY_PRODUCT_TYPE = 'SET_CART_CATEGORY_PRODUCT_TYPE'
export const SET_CART_CATEGORY_CATEGORY_ID = 'SET_CART_CATEGORY_CATEGORY_ID'
